import { ResponseDayExerciseLogs } from './../api-response/plans-response-model';
export class ExerciseData {
  constructor(
    public date: number,
    public exerciseLogs: ResponseDayExerciseLogs[],
    public updateAt: number
  ) {}
}
export class AddActivityLogParams {
  constructor(
    public user: string,
    public date: number,
    public calorie: number,
    public duration?: number,
    public name?: string,
    public exercise?: string
  ) {}
}
export class ResponseAddActivityLog {
  constructor(
    public statusCode: number,
    public exerciseLogs: ResponseDayExerciseLogs[],
    public message_id: number,
    public success: boolean
  ) {}
}

export class updateExercise {
  constructor(
    public statusCode: number,
    public exerciseLog: ResponseDayExerciseLogs,
    public message_id: number,
    public success: boolean
  ) {}
}
